function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(-247 -48)"
}, React.createElement("path", {
  d: "M335.5,48l5.6,17.2h18.1L344.6,75.8,350.1,93,335.5,82.4,320.9,93l5.6-17.2L311.8,65.2h18.1Z"
}), React.createElement("path", {
  d: "M296.5,225H249.7a2.689,2.689,0,0,1-2.7-2.7V139.8a2.689,2.689,0,0,1,2.7-2.7h46.8a2.689,2.689,0,0,1,2.7,2.7v82.5A2.689,2.689,0,0,1,296.5,225Z"
}), React.createElement("path", {
  d: "M420,224.7H374.5a3.009,3.009,0,0,1-3-3V163a3.009,3.009,0,0,1,3-3H420a3.009,3.009,0,0,1,3,3v58.7A3.076,3.076,0,0,1,420,224.7Z"
}), React.createElement("path", {
  d: "M358.4,225H312.6a3.159,3.159,0,0,1-3.2-3.2V106.6a3.159,3.159,0,0,1,3.2-3.2h45.8a3.159,3.159,0,0,1,3.2,3.2V221.8A3.159,3.159,0,0,1,358.4,225Z"
}));

var SvgLeaderboardIcon = function SvgLeaderboardIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 176,
    height: 177,
    viewBox: "0 0 176 177",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLeaderboardIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/leaderboard-Icon.7f468c02.svg";
export { ForwardRef as ReactComponent };